export const teamTranslations = {
  TEAM_TITLE: 'Ons Team',
  TEAM_SUBTITLE: 'Maak kennis met het Tranzer team!',
};
